import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';
import { useToast } from 'hooks';
import React, { FC } from 'react';
import { ToastSeverity } from 'types/toast';
import { useCopyToClipboard } from 'usehooks-ts';

interface ICopyToClipboard {
	value: string;
	tooltip: string;
	successMessage: string;
	color?: string;
}

const CopyToClipboard: FC<ICopyToClipboard> = ({
	value,
	tooltip,
	successMessage,
	color
}) => {
	const { addToast } = useToast();
	const [, copyFn] = useCopyToClipboard();

	const copyFunc = React.useCallback(async () => {
		const copied = await copyFn(value);
		if (copied) {
			addToast({
				severity: ToastSeverity.Success,
				content: successMessage
			});
		}
	}, [copyFn, value, successMessage, addToast]);

	return (
		<IconButton
			aria-label={intl.tr('button.copy')}
			edge="end"
			onClick={copyFunc}
		>
			<Tooltip title={tooltip}>
				<ContentCopyIcon fontSize="small" sx={{ color }} />
			</Tooltip>
		</IconButton>
	);
};

CopyToClipboard.defaultProps = {
	color: undefined
};

export default CopyToClipboard;
